import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiDeleteOutline } from "@mdi/js";
import {
  Button,
  Drawer,
  Input,
  Switch,
  TextField,
} from "@heroui/react";
import { feedbackSettingsStore } from "@/stores/FeedbackSettingsStore";

const TopicFormDrawer: React.FC = observer(() => {
  const store = feedbackSettingsStore;
  const {
    topicFormOpen,
    isTopicEditing,
    topicEditingUuid,
    topicForm,
    topicFormErrors,
    topicSubmitAttempted,
    topicSubmitting,
  } = store;

  const fieldError = (field: string) =>
    topicSubmitAttempted ? topicFormErrors[field] : undefined;

  const handleDelete = () => {
    if (!topicEditingUuid) return;
    store.closeTopicForm();
    store.requestDelete({
      kind: "topic",
      uuid: topicEditingUuid,
      label: topicForm.name,
    });
  };

  return (
    <Drawer.Backdrop
      isOpen={topicFormOpen}
      onOpenChange={(open) => {
        if (!open) store.closeTopicForm();
      }}
      className="fb-drawer-backdrop"
    >
      <Drawer.Content placement="right" className="fb-drawer-content">
        <Drawer.Dialog className="fb-drawer-dialog" data-testid="feedback-settings-topic-drawer">
          <Drawer.CloseTrigger data-testid="feedback-settings-topic-drawer-close" />
          <Drawer.Header className="fb-drawer-header">
            <Drawer.Heading>
              {isTopicEditing ? "Редактирование темы" : "Новая тема обращения"}
            </Drawer.Heading>
            <p className="fb-drawer-subtitle">
              Тема отображается в форме обратной связи для пользователей
            </p>
          </Drawer.Header>

          <Drawer.Body className="fb-drawer-body">
            <div className="fbs-form-field">
              <label className="fbs-form-field__label">Название *</label>
              <TextField fullWidth isInvalid={!!fieldError("name")}>
                <Input
                  value={topicForm.name}
                  onChange={(e) => store.setTopicField("name", e.target.value)}
                  placeholder="Техническая поддержка"
                />
              </TextField>
              {fieldError("name") && (
                <span className="fbs-form-field__error">
                  {fieldError("name")}
                </span>
              )}
            </div>

            <div className="fbs-visibility-row">
              <span className="fbs-form-field__label">Видимость</span>
              <Switch
                className="fbs-switch"
                isSelected={topicForm.is_active}
                onChange={(checked) => store.setTopicField("is_active", checked)}
                aria-label="Видимость темы"
              >
                <Switch.Control>
                  <Switch.Thumb />
                </Switch.Control>
              </Switch>
            </div>
          </Drawer.Body>

          <Drawer.Footer className="fbs-drawer-footer">
            <div className="fbs-drawer-footer__actions">
              {isTopicEditing ? (
                <Button
                  variant="ghost"
                  className="fbs-drawer-footer__delete"
                  onPress={handleDelete}
                >
                  <Icon path={mdiDeleteOutline} size={0.8} />
                  Удалить
                </Button>
              ) : (
                <span />
              )}
              <div className="fbs-drawer-footer__spacer" />
              <Button
                variant="tertiary"
                onPress={() => store.closeTopicForm()}
                data-testid="feedback-settings-topic-cancel"
              >
                Отмена
              </Button>
              <Button
                variant="primary"
                onPress={() => void store.submitTopic()}
                isPending={topicSubmitting}
                data-testid="feedback-settings-topic-submit"
              >
                Сохранить
              </Button>
            </div>
          </Drawer.Footer>
        </Drawer.Dialog>
      </Drawer.Content>
    </Drawer.Backdrop>
  );
});

TopicFormDrawer.displayName = "TopicFormDrawer";
export default TopicFormDrawer;
